import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../feature-module/dashboard/Dashboard";

// Masters
import PatientList from "../feature-module/patients/PatientList";
import ProcedureList from "../feature-module/procedures/ProcedureList";
import DoctorList from "../feature-module/doctors/DoctorList";
import ProductList from "../feature-module/products/ProductList";
import SupplierList from "../feature-module/suppliers/SupplierList";
import AccountHeadList from "../feature-module/account-heads/AccountHeadList";

// Appointments
import AppointmentCalendar from "../feature-module/appointments/AppointmentCalendar";
import AppointmentList from "../feature-module/appointments/AppointmentList";

// Billing
import InvoiceList from "../feature-module/invoices/InvoiceList";
import InvoiceForm from "../feature-module/invoices/InvoiceForm";
import BillWiseReceipt from "../feature-module/invoices/BillWiseReceipt";
import InvoicePrint from "../feature-module/invoices/InvoicePrint";

// Purchases
import PurchaseList from "../feature-module/purchases/PurchaseList";
import PurchaseReturnList from "../feature-module/purchases/PurchaseReturnList";
import OpeningStock from "../feature-module/purchases/OpeningStock";

// Stock
import CurrentStock from "../feature-module/stock/CurrentStock";
import StockAdjustment from "../feature-module/stock/StockAdjustment";

// Finance
import ExpenseList from "../feature-module/finance/ExpenseList";
import IncomeList from "../feature-module/finance/IncomeList";
import JournalList from "../feature-module/finance/JournalList";
import SupplierAdvance from "../feature-module/finance/SupplierAdvance";
import SupplierPayments from "../feature-module/finance/SupplierPayments";

// Reports
import AppointmentReport from "../feature-module/Reports/AppointmentReport";
import SalesReport from "../feature-module/Reports/SalesReport";
import PurchaseReport from "../feature-module/Reports/PurchaseReport";
import ExpenseReport from "../feature-module/Reports/ExpenseReport";
import StockReport from "../feature-module/Reports/StockReport";
import StockMovement from "../feature-module/Reports/StockMovement";
import CustomerStatement from "../feature-module/Reports/CustomerStatement";
import SupplierStatement from "../feature-module/Reports/SupplierStatement";
import Receivables from "../feature-module/Reports/Receivables";
import Payables from "../feature-module/Reports/Payables";
import MISReport from "../feature-module/Reports/MISReport";
import DailyReport from "../feature-module/Reports/DailyReport";
import PaymentReport from "../feature-module/Reports/PaymentReport";
import PatientHistory from "../feature-module/Reports/PatientHistory";

// Settings
import UserList from "../feature-module/settings/UserList";
import RolesPermissions from "../feature-module/settings/RolesPermissions";
import AuditLog from "../feature-module/settings/AuditLog";
import TestDataSeeder from "../feature-module/settings/TestDataSeeder";

// Auth pages (kept from template)
import SignIn from "../feature-module/pages/login/signin";
import Logout from "../feature-module/pages/Logout";

export const publicRoutes = [
  { path: "/", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard", element: <Dashboard /> },

  // Masters
  { path: "/patients", element: <PatientList /> },
  { path: "/procedures", element: <ProcedureList /> },
  { path: "/doctors", element: <DoctorList /> },
  { path: "/products", element: <ProductList /> },
  { path: "/suppliers", element: <SupplierList /> },
  { path: "/account-heads", element: <AccountHeadList /> },

  // Appointments
  { path: "/appointments", element: <AppointmentCalendar /> },
  { path: "/appointment-list", element: <AppointmentList /> },

  // Billing
  { path: "/invoices", element: <InvoiceList /> },
  { path: "/invoices/new", element: <InvoiceForm /> },
  { path: "/invoices/:id/edit", element: <InvoiceForm /> },
  { path: "/invoices/bill-wise-receipt", element: <BillWiseReceipt /> },
  { path: "/invoices/:id/print", element: <InvoicePrint /> },

  // Purchases
  { path: "/purchases", element: <PurchaseList /> },
  { path: "/purchase-returns", element: <PurchaseReturnList /> },
  { path: "/opening-stock", element: <OpeningStock /> },

  // Stock
  { path: "/stock", element: <CurrentStock /> },
  { path: "/stock-adjustment", element: <StockAdjustment /> },

  // Finance
  { path: "/expenses", element: <ExpenseList /> },
  { path: "/income", element: <IncomeList /> },
  { path: "/journal", element: <JournalList /> },
  { path: "/supplier-advance", element: <SupplierAdvance /> },
  { path: "/supplier-payments", element: <SupplierPayments /> },

  // Reports
  { path: "/reports/appointments", element: <AppointmentReport /> },
  { path: "/reports/sales", element: <SalesReport /> },
  { path: "/reports/purchases", element: <PurchaseReport /> },
  { path: "/reports/expenses", element: <ExpenseReport /> },
  { path: "/reports/stock", element: <StockReport /> },
  { path: "/reports/stock-movement", element: <StockMovement /> },
  { path: "/reports/customer-statement", element: <CustomerStatement /> },
  { path: "/reports/supplier-statement", element: <SupplierStatement /> },
  { path: "/reports/receivables", element: <Receivables /> },
  { path: "/reports/payables", element: <Payables /> },
  { path: "/reports/mis", element: <MISReport /> },
  { path: "/reports/daily", element: <DailyReport /> },
  { path: "/reports/payments", element: <PaymentReport /> },
  { path: "/reports/patient-history", element: <PatientHistory /> },

  // Settings
  { path: "/users", element: <UserList /> },
  { path: "/roles-permissions", element: <RolesPermissions /> },
  { path: "/audit-log", element: <AuditLog /> },
  { path: "/seed-data", element: <TestDataSeeder /> },
];

export const pagesRoute = [
  { path: "/signin", element: <SignIn /> },
  { path: "/logout", element: <Logout /> },
];

export const posRoutes = [];
